import { render, staticRenderFns } from "./GenericTriangle.vue?vue&type=template&id=9da98c84&scoped=true&"
import script from "./GenericTriangle.vue?vue&type=script&lang=js&"
export * from "./GenericTriangle.vue?vue&type=script&lang=js&"
import style0 from "./GenericTriangle.vue?vue&type=style&index=0&id=9da98c84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da98c84",
  null
  
)

export default component.exports